import { supabase } from "@/integrations/supabase/client";

export type EnsembleResult = {
  winner: { modelId: string; content: string; ms: number; ok: boolean };
  results: Array<{ modelId: string; content: string; ms: number; ok: boolean; error?: string }>;
  voting: { winnerIndex: number; reason: string; merged: string } | null;
  totalMs: number;
};

export async function callEnsemble(args: {
  prompt: string;
  models: string[];
  ensemble?: boolean;
  system?: string;
}): Promise<EnsembleResult> {
  const { data, error } = await supabase.functions.invoke("multi-model-ensemble", {
    body: {
      prompt: args.prompt,
      models: args.models,
      ensemble: args.ensemble ?? args.models.length > 1,
      system: args.system,
    },
  });
  if (error) throw error;
  return data as EnsembleResult;
}
